import * as React from 'react';

interface BorderedInfoCardProps {
    heading: string;
    title: number;
    biggerTitle?: boolean;
    showTitleWithPercentage?: boolean;
    subText1?: string;
    subText2?: string;
    breakSubText?: string;
    percentage?: number;
    showSecondContainer?: boolean;
  }

export const BorderedInfoCard = ({ heading, title, biggerTitle, subText1, subText2, breakSubText, percentage, showTitleWithPercentage, showSecondContainer }: BorderedInfoCardProps) => {


    let showInfoIcon = (title==0)

    if(showSecondContainer && showInfoIcon){
       showInfoIcon = (percentage==0)
    }

    return (
        <div className='bordered-card-layout'>
            <p className='dashboard-heading'>{heading}</p>
            <div className='dashboard-covered-conatiner'>
                <p className={ biggerTitle? 'dashboard-bigger-title': 'dashboard-title'}>{showInfoIcon? "N/A" :title.toLocaleString('en-US')+ (showTitleWithPercentage?"%":"")}</p>
                {subText1 && <p className='sub-text'>{subText1}</p>}
                {showSecondContainer? (
                <div className="dashboard-section">
                    <div className="dashboard-line"></div>
                    <div className='dasboard-sub-container'>
                      <p className='dashboard-title'>{showInfoIcon? "N/A" :percentage+"%"}</p>
                      <p className='sub-text'>
                        {subText2}
                        {breakSubText && <br />}
                        {breakSubText !== undefined ? breakSubText : ""}
                      </p>
                    </div>
                </div>
                ) : (
                subText2 && <p className='sub-text'>{subText2}</p>
                )}
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/admin/analyticsDashboardWidgets/borderedInfoCard.tsx